import { VISION_INPUT } from './topics';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import type { PersonType } from './personIdentified';
import { personTypesSchema } from './personIdentified';

export const NEW_FACE = 'VISION/NEW_FACE' as const;

export interface INewFaceActionPayload {
  faceId: string;
  faceToken: string;
  organisationId: string;
  type: PersonType;
  staffId?: string;
  visitorId?: string;
}

export interface INewFaceAction {
  type: typeof NEW_FACE;
  payload: INewFaceActionPayload;
}

export const newFaceActionSchema = objectSchemaOf<INewFaceAction>({
  type: Joi.string().valid(NEW_FACE).required(),
  payload: objectSchemaOf<INewFaceActionPayload>({
    faceId: Joi.string().required(),
    faceToken: Joi.string().required(),
    organisationId: Joi.string().required(),
    type: personTypesSchema.required(),
    staffId: Joi.string().optional(),
    visitorId: Joi.string().optional(),
  }).required(),
});

export const newFace = actionCreator({
  type: NEW_FACE,
  schema: newFaceActionSchema,
  topic: VISION_INPUT,
});
